import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AccordionItemComponent } from './accordion-item/accordion-item.component'
import { FaqItem } from '../../interfaces/faq.interface'
import { ButtonComponent } from '../button/button.component'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { ApiService, UserInfo } from 'app/services/api.service'
import { LinkComponent } from '@components/link/link.component'
import { environment } from '../../../environments/environment';
import { HomeLinksService } from '../../services/home-links.service'

@Component({
    selector: 'app-faq-benefits',
    standalone: true,
    imports: [CommonModule, AccordionItemComponent, ButtonComponent, TranslateModule,LinkComponent],
    templateUrl: './faq-benefits.component.html',
    styleUrls: ['./faq-benefits.component.scss'],
})
export class FaqBenefitsComponent {
    userInfo: UserInfo
    faqItems: FaqItem[] = []
    public isLoyalty2026Active: boolean = environment.loyalty2026

    constructor(
        private api: ApiService,
        private translate: TranslateService,
        private homeLinksService: HomeLinksService,
    ) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
        })
        this.faqItems = [
            {
                key: 'level_advance',
                question: this.translate.instant('benefits_kb.faq.level_advance.question'),
                answer: this.translate.instant('benefits_kb.faq.level_advance.answer'),
                isOpen: false,
            },
            {
                key: 'level_update',
                question: this.translate.instant('benefits_kb.faq.level_update.question'),
                answer: this.translate.instant('benefits_kb.faq.level_update.answer'),
                isOpen: false,
            },
            {
                key: 'level_down',
                question: this.translate.instant('benefits_kb.faq.level_down.question'),
                answer: this.translate.instant('benefits_kb.faq.level_down.answer'),
                isOpen: false,
            },
        ]
    }

    goToWeCommerce() {
        this.homeLinksService.goToWecommerce()
    }
}
